//import React, { useState } from "react";
// import DatePicker from "react-horizontal-datepicker";
//import { useForm } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";

function AppointmentStep6() {
  
  
    return (
      <div className="row justify-content-md-center">
        <div className="appointmentBackground"></div>
        <div className="col col-lg-5">
          <h3 className="mt-5 mb-3">Confirm Appointment</h3>
          <form>
            <div className="card pb-3 p-3 boxviewtransperant">
              <div className="card-body">
                <div className="row mt-3">
                  <div className="col-md-4">asfsadf</div>
                  <div className="col-md-8"></div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <button
                  className="btn btn-secondary btn-block"
                  style={{ width: "100%" }}
                >
                  Continue
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  
}

export default AppointmentStep6;
